import { useState, useEffect } from "react";
import { client } from "../prismic";
import { SliceZone } from "@prismicio/react";
import { components } from "../slices/components";

import '../scss/homePage.scss';
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";

export default function HomePage() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const document = await client.getByUID('pages', 'home');
        setDoc(document);
      } catch (error) {
        console.warn("No se encontró el documento de Prismic para el HomePage aún.", error.message);
      }
    };
    fetchDoc();
  }, []);

  return (
    <>
      <LoadingScreen isLoading={!doc} />
      {doc && doc.data && (
        <SliceZone
          slices={doc.data.slices || doc.data.body || []}
          components={components}
        />
      )}
    </>
  )
}